<template>
    <div class="container">
        <div class="container-body">
            <div class="container-body-box" v-if="finished" v-watermark>
                <div class="header">
                    <div class="header-box">
                        <p>成都双流润生医荃宜互联网医院</p>
                        <p>互联网医院电子病历</p>
                    </div>
                </div>
                <div class="form">
                    <div class="form-item">
                        <div class="form-item-box">
                            <div class="item">
                                <div class="label">本次订单</div>
                                <div class="value">{{  form.electronicMedicalRecordNo  }}</div>
                            </div>
                            <div class="item">
                                <div class="label">就诊科室</div>
                                <div class="value">{{  form.deptName  }}</div>
                            </div>
                            <div class="item">
                                <div class="label">接诊医生</div>
                                <div class="value">{{  form.doctorName  }}</div>
                            </div>
                            <div class="item">
                                <div class="label">就诊卡号</div>
                                <div class="value">{{  form.medicalInsuranceNo  }}</div>
                            </div>
                            <div class="item">
                                <div class="label">就诊时间</div>
                                <div class="value">{{  form.treatmentTime  }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-item-title">病人信息</div>
                        <div class="form-item-box">
                            <div class="item half">
                                <div class="label">病人姓名</div>
                                <div class="value">{{  form.patientName  }}</div>
                            </div>
                            <div class="item half">
                                <div class="label">性别</div>
                                <div class="value">{{  form.patientSex | sexFilter  }}</div>
                            </div>
                            <div class="item half">
                                <div class="label">出生日期</div>
                                <div class="value">{{  onPatientBirthday(form.patientBirthday)  }}</div>
                            </div>
                            <div class="item half">
                                <div class="label">年龄</div>
                                <div class="value">{{  form.patientAge  }}</div>
                            </div>
                            <div class="item half-small">
                                <div class="label">婚否</div>
                                <div class="value">{{  form.maritalStatus  }}</div>
                            </div>
                            <div class="item half-small">
                                <div class="label">民族</div>
                                <div class="value">{{  form.patientNation || '无'  }}</div>
                            </div>
                            <div class="item half-big nowrap">
                                <div class="label">身份证号</div>
                                <div class="value">{{  form.idCard  }}</div>
                            </div>
                            <div class="item half-big">
                                <div class="label">电话号码</div>
                                <div class="value">{{  form.patientMobile  }}</div>
                            </div>
                            <div class="item half-big">
                                <div class="label">是否复诊</div>
                                <div class="value">{{  form.offlineVisit == 2 ? '无' : form.offlineVisit == 1 ? '是' : '否'  }}</div>
                            </div>
                            <!-- <div class="item half-small">
                                <div class="label">邮编</div>
                                <div class="value">{{  form.postalCode  }}</div>
                            </div> -->
                            <div class="item half-big">
                                <div class="label">就诊类型</div>
                                <div class="value">{{  form.treatmentType  }}</div>
                            </div>
                            <!-- <div class="item half-small">
                                <div class="label">职业</div>
                                <div class="value">{{  form.patientOccupation || '无'  }}</div>
                            </div>
                            <div class="item">
                                <div class="label">工作单位</div>
                                <div class="value">{{  form.workUnit || '无'  }}</div>
                            </div>
                            <div class="item">
                                <div class="label">家庭地址</div>
                                <div class="value">{{  form.patientAddress || '无'  }}</div>
                            </div> -->
                            <div class="item">
                                <div class="label">主诉</div>
                                <div class="value">{{  form.askIllness || '无'  }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="form-item">
                        <div class="form-item-title">问诊症状</div>
                        <div class="form-item-box">
                            <div class="item">
                                <div class="label">现病史</div>
                                <div class="value">{{  form.illnessDescription || '无'  }}</div>
                            </div>
                            <div class="item">
                                <div class="label">既往史</div>
                                <div class="value">{{  form.medicalHistory || '无'  }}</div>
                            </div>
                            <div class="item">
                                <div class="label">过敏史</div>
                                <div class="value">{{  form.allergyHistory || '无'  }}</div>
                            </div>
                            <div class="item">
                                <div class="label">生育史</div>
                                <div class="value">{{  form.maternityStatus || '无'  }}</div>
                            </div>
                            <div class="item">
                                <div class="label">月经史</div>
                                <div class="value">{{  form.menstrualHistory || '无'  }}</div>
                            </div>
                            <div class="item">
                                <div class="label">家族史</div>
                                <div class="value">{{  form.familyHistory || '无'  }}</div>
                            </div>
                            <div class="item">
                                <div class="label">辅助检查</div>
                                <div class="value">{{  form.auxiliaryExamination || '无'  }}</div>
                            </div>
                            <div class="item">
                                <div class="label">疾病诊断</div>
                                <div class="value">{{  form.patientDiagnose || '无'  }}</div>
                            </div>
                            <div class="item">
                                <div class="label">处置意见</div>
                                <div class="value">{{  form.treatmentSuggestion || '无'  }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-body-box" v-else-if="!loading">
                <van-empty description="加载失败" />
            </div>
        </div>
        <div class="container-btn">
            <van-button type="info" @click="$router.back()">关闭</van-button>
        </div>
    </div>
</template>
<script>
import { getMedicalRecord } from '@/api/index'
export default {
    data() {
        return {
            submit: true,
            loading: true,
            finished: false,
            form: {}
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.onDataGet()
        },
        onDataGet() {
            this.loading = true;
            getMedicalRecord({
                askNo: this.$route.query.askNo,
                userNo: this.$route.query.userNo
            }).then(({ code, data }) => {
                if (code == 0) {
                    this.form = data;
                    this.loading = false;
                    this.finished = true;
                }
            }).catch(({ message }) => {
                this.loading = false;
            })
        },
        onPatientBirthday(date) { // 生日格式
            if (date) {
                let time = new Date(date);
                let year = time.getFullYear();
                let month = time.getMonth() + 1;
                let day = time.getDate();
                return year + '-' + month + '-' + day;
            } else {
                return ''
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.container {
    background: #f2f2f2;

    &-body {
        padding: 10px;

        &-box {
            background: #fff;
            padding: 15px;
            border-radius: 6px;
            height: calc(100vh - 154px);
            overflow-y: auto;

            .header {
                &-box {
                    font-weight: bold;
                    text-align: center;
                    line-height: 1;
                }
            }

            .form {
                &-item {
                    border-top: 1px solid #efefef;
                    padding-top: 20px;
                    margin-top: 10px;
                    font-size: 18px;

                    &-title {
                        font-weight: bold;
                        margin-bottom: 15px;
                        display: flex;
                        align-items: center;

                        &::before {
                            content: "";
                            width: 6px;
                            height: 6px;
                            border-radius: 4px;
                            background: #0082ef;
                            margin-right: 5px;
                            margin-top: 5px;
                        }
                    }

                    &-box {
                        display: flex;
                        flex-wrap: wrap;
                    }

                    .item {
                        // display: flex;
                        margin-bottom: 15px;
                        width: 100%;
                        line-height: 1.5;

                        &.half-big {
                            width: 60%;
                        }

                        &.half-small {
                            width: 40%;
                        }

                        &.nowrap {
                            white-space: nowrap;
                        }

                        .label,
                        .value {
                            display: inline;
                        }

                        .label {
                            color: #666;
                        }

                        .value {
                            margin-left: 10px;
                            font-weight: bold;
                            word-break: break-all;
                        }
                    }
                }
            }
        }
    }

    &-btn {
        background: #fff;
        padding: 20px;
        margin-top: 10px;

        .van-button {
            width: 100%;
            border-radius: 6px;
        }
    }
}
</style>